import { TIME_OFF_REQUEST_TYPE, TIME_OFF_STATUS, TIME_OFF_TYPE } from './constant'

export default {
  getTimeOffStatus() {
    return status => {
      return TIME_OFF_STATUS[String(status)]
    }
  },
  getTimeOffType() {
    return status => {
      return TIME_OFF_TYPE[String(status)]
    }
  },
  getTimeOffRequestType() {
    return status => {
      return TIME_OFF_REQUEST_TYPE[String(status)]
    }
  }
}
